// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".email-row[data-v-45c09027] {\n  transition: background-color 0.2s;\n}[dir] .email-row[data-v-45c09027] {\n  cursor: pointer;\n  -webkit-transition: background-color 0.2s;\n}\n[dir] .email-row[data-v-45c09027]:hover {\n  background-color: #f8f9fa !important;\n}\n", ""]);
// Exports
module.exports = exports;
